import { camelCaseKeys, useFlags } from 'launchdarkly-react-client-sdk'
import { useStore } from 'zustand'

import {
  DEFAULT_FEATURE_FLAG_VALUES,
  type GremlinClientFlags
} from 'components/LaunchDarklyProvider'
import { appConfig, isPrivateEdition } from 'utils/app-config'

/**
 * MAKE SURE YOU UPDATE `DEFAULT_FEATURE_FLAG_VALUES` IN `src/components/LaunchDarklyProvider.tsx`
 */
export function useFeatureFlags(): GremlinClientFlags {
  const ldFlags = useFlags<GremlinClientFlags>()
  // Overrides are only possible with Private Edition deployments
  // NOTE: The expected format for each flag's key is camelCase
  const flagOverrides = useStore(appConfig, (state) => state?.featureFlags)

  return isPrivateEdition()
    ? { ...camelCaseKeys(DEFAULT_FEATURE_FLAG_VALUES), ...flagOverrides }
    : ldFlags
}
